import { useState } from "react";
import Campo from "../Campo";
import styles from "./styles.module.css";
import {
  addList,
  editList,
  removeList,
} from "../../controllers/ListOperations";
import { BensAdiquiridoProduzido } from "../../model/PrestacaoDeContas/RelacaoBens";
import { useMask } from "@react-input/mask";
import { numberMask } from "../../controllers/Masks";
import CampoTextoLongo from "../Campo/CampoTextoLongo";

type Props = {
  refBem?: BensAdiquiridoProduzido;
  closeModal: Function;
  list: BensAdiquiridoProduzido[];
  setList: React.Dispatch<React.SetStateAction<BensAdiquiridoProduzido[]>>;
  index?: number;
};

const ModalRelacaoBens = ({
  refBem,
  closeModal,
  list,
  setList,
  index,
}: Props) => {
  const [tipoDocumento, setTipoDoc] = useState(refBem?.tipo || "NF");
  const [numDocumento, setNumDoc] = useState(refBem?.numero || "1");
  const [dataDocumento, setDataDoc] = useState(
    refBem?.data || new Date(Date.now())
  );
  const [especificacao, setEspecificacao] = useState(
    refBem?.especificacaoBens || ""
  );

  const [quantidade, setQuantidade] = useState(refBem?.quantidade || 1);
  const [valor, setValor] = useState(refBem?.valor || 0);

  return (
    <form className={styles.formModal}>
      <h2>Pagamento Efetuado</h2>
      <div className={styles.camposDados}>
        <div className={styles.gridCampos}>
          <Campo
            title="Tipo"
            type="text"
            maxLength={64}
            required={true}
            setter={setTipoDoc}
            value={tipoDocumento}
          />
          <Campo
            title="Numero"
            type="text"
            mask={useMask(numberMask)}
            maxLength={64}
            required={true}
            setter={setNumDoc}
            value={numDocumento}
          />
        </div>
        <Campo
          title="Data do Documento"
          type="date"
          maxLength={64}
          required={true}
          setter={setDataDoc}
          value={dataDocumento}
        />
        <CampoTextoLongo
          title="Especificação"
          placeholder="Preencha com a Especificação do bem adquirido"
          required={true}
          customValidity="Preencha com a Especificação do bem adquirido"
          setter={setEspecificacao}
          value={especificacao}
        />
        <div className={styles.gridCampos}>
          <Campo
            title="Quantidade"
            type="number"
            maxLength={64}
            required={true}
            setter={setQuantidade}
            value={quantidade}
          />
          <Campo
            title="Valor Unitário"
            type="number"
            maxLength={64}
            required={true}
            setter={setValor}
            value={valor}
          />
        </div>
      </div>

      {!refBem && (
        <input
          type="submit"
          value="+ Adicionar Relatório"
          className={styles.addBtn}
          onClick={(e) => {
            e.preventDefault();
            const item: BensAdiquiridoProduzido = {
              tipo: tipoDocumento,
              numero: numDocumento,
              data: dataDocumento,
              especificacaoBens: especificacao,
              quantidade: quantidade,
              valor: valor,
            };

            addList({
              item,
              list,
              setList,
            });
            closeModal();
          }}
        />
      )}
      {refBem !== undefined && index !== undefined && (
        <div className={styles.gridCampos}>
          <input
            type="submit"
            value="Editar Relatório"
            className={styles.addBtn}
            onClick={(e) => {
              e.preventDefault();
              const item: BensAdiquiridoProduzido = {
                tipo: tipoDocumento,
                numero: numDocumento,
                data: dataDocumento,
                especificacaoBens: especificacao,
                quantidade: quantidade,
                valor: valor,
              };
              editList({
                item,
                index,
                list,
                setList,
              });
              closeModal();
            }}
          />
          <input
            type="submit"
            value="Remover Meta"
            className={styles.removeBtn}
            onClick={(e) => {
              e.preventDefault();
              removeList({
                index,
                list,
                setList,
              });
              closeModal();
            }}
          />
        </div>
      )}
    </form>
  );
};

export default ModalRelacaoBens;
